<template>
    <div>
        <div v-if="!obj.calledFromEdit" id="xButt" class="delete top10" @click="$parent.closeRightBar" style="z-index: 5"></div>
        <div v-if="!obj.calledFromEdit" style="position: fixed; width: 415px;  z-index: 2" class="has-background-dark">
            <div class="has-background-dark has-text-white is-size-4 bottom10 pad10 ">COMMENTS</div>
           
            <div class="has-text-white is-size-5 top-10 has-background-black" style="padding-bottom: 4px">
                <div class="is-inline-block top10 left10 has-background-dark" style="vertical-align: top; height: 29px; width: 47px; overflow: hidden">
                   <img :src="obj.item.img"  class="has-background-light" />
                </div>
               <div class="is-inline-block commentsCardHeader top10 is-size-6">&nbsp;<b>{{obj.item.title}}</b></div>
            </div>
        </div>
        <div v-if="!obj.calledFromEdit"><br><br><br><br><br></div>
       
        <div class="posRelative top8">
            <div class="is-inline-block has-text-white is-pulled-left top10 left10">{{comments.length}} Comment{{comments.length == 0 || comments.length > 1 ? 's' : ''}}</div>
            <div v-if="parentPublic" class="is-inline-block top10 left10">
                <span v-show="obj.collabId" class="is-size-7 handCursor" :class="{commentsToggle: !inPublic}" @click="flipPublic">collab</span> 
                <span> | </span>
                <span class="is-size-7 handCursor" :class="{commentsToggle: inPublic}" @click="flipPublic">public</span>
            </div> 
            <button class="button is-coolGreen tiny top6 bottom5 posRight" :class="{addBtnCommentsEdit: obj.calledFromEdit, addBtnCommentsRightPanel: !obj.calledFromEdit}" @click="addComment(null, null, null, -1)">Add+</button>
            <br>
            <div v-if="add" class="commentAdd">
                <div v-if="newCommParentId" class="is-size-6 left5">Replying to <span class="has-text-coolGreen"><b>{{replyingTo}}</b>:</span></div>
                <textarea v-model="commentText" rows="3"></textarea>
                <div class="is-pulled-right left12">
                    <button class="button tiny" @click="cancel">CANCEL</button>&nbsp;
                    <button :disabled="commentText == ''" class="button tiny is-coolGreen" @click="save">SAVE</button>
                </div>
            </div>
            <div >&nbsp;</div>

            <div id="commentContainer" style="position: absolute; top: 200px; left: 180px">

            </div>

            <div class="commentsBlock" :class="{inPublic: this.obj.inRightBar}" >
                <!--COMMENT BLOCK -->
                <div ref="posts" v-for="(c, i) in comments" :key="i"  class="has-text-white posRelative comment bottom20" :class="{'commIndent1' : c.lev == 1, commIndent2 : c.lev == 2, commIndent3 : c.lev == 3}">
                    <div class="has-background-grey">
                        <div class="is-inline-block is-size-8" style="position: relative; top: -2px; left: 2px">&nbsp;<timeago :datetime="c.dateCreated"></timeago><!-- &nbsp;{{az.dateConvert(c.dateCreated)}} --></div>
                        <div class="is-inline-block is-size-7 posRight top-2"><i v-if="c.id_cog == $root.app.userAttrs.sub" class="fa fa-pen handCursor" @click="edit(i, c.comment)"></i>&nbsp;{{inPublic ? c.handle : c.fName + ' ' + c.lName}}</div>
                    </div>
    
                    <div ref="commentDiv" class=" has-text-white commentText is-size-75" v-html="c.comment" v-linkified>
                        
                    </div>


                    <div v-if="c.lev < 3" class="is-size-7 left10 has-text-coolGreen handCursor" @click="addComment(c.id, c.rootId, inPublic ? c.handle : c.fName + ' ' + c.lName, c.lev)">Reply</div>
                   
                    <div ref="controls" class="has-background-dark top10 hideIt top-3">
                        <div ref="editDiv">
                            <textarea rows="3" v-model="commentForEdit" style="width: 377px; padding: 3px"></textarea>
                        </div>
                        &nbsp;<button class="button tiny" v-show="!sure" @click="sure = true">DELETE</button>
                         &nbsp;<span v-show="sure" class="has-text-white is-size-7"><b>Are you sure?</b>&nbsp;<button class="button is-coolGreen tiny" @click="del(i, c.id)">YES</button> <button class="button tiny" @click="sure = false">NO</button></span>

                        <div class="is-pulled-right">
                            <button class="button tiny" @click="cancelEdit(i)">CANCEL</button>&nbsp;
                            <button class="button is-coolGreen tiny" @click="saveEdit(i, c.id)">SAVE</button>
                        </div>
                    </div>
                </div>
                <!--/COMMENT BLOCK -->
            </div>
            
            <br>
        </div>

    </div>
</template>

<script>

export default {

    props: {
        obj: {
            type: Object,
            default: function(){ return {}}
        }
    },
    data: function(){
        return {
            az: az,
            add: false,
            commentText: '',
            sure: false,
            commentForEdit: '',
            inPublic: false,
            allComments: [],
            parentPublic: this.$parent.parentPublic,
            comments: [],
            newCommParentId: null,
            newCommRootId: null,
            replyingTo: '',
            newCommentLev: 0,
            limit: 8,
            offsetC: 0,
            offsetP: 0
        }
    },

     mounted: function(){

     
        var self = this;

        var observer = new IntersectionObserver(function(entries) {
                    // isIntersecting is true when element and viewport are overlapping
                    // isIntersecting is false when element and viewport don't overlap
                    if(entries[0].isIntersecting === true){
                        
                        observer.disconnect()
                        self.getMore()
                    }
                    
                }, { threshold: [0] });


        document.getElementById('rightBar').style['z-index'] = 10200

        if(this.obj.calledFromEdit){
            this.inPublic = false
        } else {
            this.inPublic = true
        }

        function w(d){
            
            if(d.r.length){
                var t = self.buildCommentTree(d.r)
                self.allComments = t
                
                self.setComments()
                if(self.inPublic)
                    self.offsetP += self.limit;
                else
                    self.offsetC += self.limit

                setTimeout(function(){
                    observer.observe(self.$refs.posts[self.comments.length - 1]);
                }, 10)
            }
            az.addRemSpinner(false, 'id', 'commentContainer')

           
        }

        function n(){
            az.addRemSpinner(false, 'id', 'commentContainer')
        }
        if(!self.obj.selectPublic && !self.$parent.callApi){  //no need to call comments when creating new miimu
            az.addRemSpinner(true, 'id', 'commentContainer')
            var forOffset = this.inPublic ? this.offsetP : this.offsetC
            this.$root.app.apiClient.get(`subs/data/comments/${this.obj.item.id}/${this.limit}/${forOffset}/${this.inPublic}`, {}, w, n)

        } else {
            this.flipPublic()
        }


        //for public non-collabs
      
        if(this.parentPublic && !this.obj.collabId){
            this.flipPublic()
        }
    },

    methods: {

        getMore: function(){

            if(this.$parent.callApi) return //no need to call comments when creating new miimu

            var self = this

            var observer = new IntersectionObserver(function(entries) {
                    // isIntersecting is true when element and viewport are overlapping
                    // isIntersecting is false when element and viewport don't overlap
                    if(entries[0].isIntersecting === true){
                        
                        observer.disconnect()
                        self.getMore()
                    }
                    
                }, { threshold: [0] });
            
            function w(d){

                if(d.r.length){
                    
                    var t = self.buildCommentTree(d.r)
                    t.forEach(e => {
                        self.allComments.push(e)
                    })
                    
                    self.setComments()
                    if(self.inPublic)
                        self.offsetP += self.limit;
                    else
                        self.offsetC += self.limit

                    setTimeout(function(){
                        observer.observe(self.$refs.posts[self.comments.length - 1]);
                    }, 10)
                }
                az.addRemSpinner(false, 'id', 'commentContainer')
            }

            function n(){
                az.addRemSpinner(false, 'id', 'commentContainer')
            }
            az.addRemSpinner(true, 'id', 'commentContainer')
            var forOffset = this.inPublic ? this.offsetP : this.offsetC
            this.$root.app.apiClient.get(`subs/data/comments/${this.obj.item.id}/${this.limit}/${forOffset}/${this.inPublic}`, {}, w, n)
        },

        buildCommentTree: function(base){
                var cTree = [];

                var roots = base.filter(e => {
                    return e.parentId == null
                })

                roots.sort((a,b) => {
                    return b.id - a.id
                })

                roots.forEach(e => {
                    e.lev = 0;
                    cTree.push(e)
                })

               

                var lev = 1
                function rec(arr){

                    arr.forEach((e, ind) => {

                        var g = base.filter(n => {
                            return n.parentId == e.id
                        })

                        g.sort((a,b) => {
                            return a.id - b.id
                        })

                        g.forEach(x => {
                            x.lev = lev
                        })

                        var ite = cTree.findIndex(i => {
                            return e.id == i.id
                        })

                        cTree.splice(ite+1, 0, ...g)
                        
                        if(g.length){
                            lev++
                            rec(g)
                        }
                    })

                    lev = 1
                }

                rec(roots)
                return cTree

        },

        cancel: function(){
            this.newCommParentId = null;
            this.newCommParentId = null;
            this.commentText = ''
            this.add = false
        },

        save: function(lev){
             var self = this;

             if(this.commentText == ''){
                 return
             }

            function w(d){
                az.addRemSpinner(false, 'id', 'commentContainer')
                
                d.r.lev = self.newCommentLev
                
                if(self.newCommParentId == null){
                    self.allComments.unshift(d.r)
                } else {
                    //find index of parent
                    var ind = self.allComments.findIndex(e => {
                        return e.id == self.newCommParentId
                    })

                    for(var x = ind; self.allComments[x].parentId == self.newCommParentId; x++){
                       //do nothing, just need value of x after done
                    }

                    self.allComments.splice(x + 1, 0, d.r)
                    
                }
                
                self.setComments()
                self.cancel()
            }

            function n(){
                az.addRemSpinner(false, 'id', 'commentContainer')
            }
            az.addRemSpinner(true, 'id', 'commentContainer')
            this.$root.app.apiClient.post(`subs/data/comments`, {comment: this.commentText, id_CARDS: this.obj.item.id, id_BUNDLES: this.obj.bundleId,  collabId: this.obj.collabId, isPublic: this.inPublic, parentId: this.newCommParentId, rootId: this.newCommRootId}, w, n)

        },

        reply: function(){

        },

        edit: function(i, comment){
            this.$refs.controls.forEach(e => {
                e.classList.add('hideIt')
            })

            this.commentForEdit = comment

            this.$refs.controls[i].classList.remove('hideIt')
            this.$refs.commentDiv[i].classList.add('hideIt')
        },

        cancelEdit: function(i){
            this.$refs.controls[i].classList.add('hideIt')
            this.$refs.commentDiv[i].classList.remove('hideIt')
        },

        flipPublic: function(){
            document.getElementsByClassName('commentsBlock')[0].scrollTo(0,0)
            this.inPublic = !this.inPublic
            this.add = false
            this.newCommParentId = null
            this.newCommRootId = null
            this.getMore()
            this.setComments()
           
        },

        setComments: function(){
            if(this.inPublic){
                this.comments = this.allComments.filter(e => {
                    return e.isPublic == 1
                })
            } else {
                this.comments = this.allComments.filter(e => {
                    return !e.isPublic
                })
            }
        },

        del: function(i, id){

            var self = this
            function w(d){
                az.addRemSpinner(false, 'id', 'commentContainer')
                if(d.r == 'ok'){
                    self.comments.splice(i, 1)
                    var toDelete = self.allComments.findIndex(e => {
                        return e.id == id
                    })

                    self.allComments.splice(toDelete, 1)

                    

                }
            }

            function n(){
                az.addRemSpinner(false, 'id', 'commentContainer')
            }
            az.addRemSpinner(true, 'id', 'commentContainer')
            this.sure = false
            this.cancelEdit(i)
            this.$root.app.apiClient.delete('subs/data/comment', {id: id}, w, n)
        },

        addComment: function(parentId, rootId, replyTo, lev){
            this.newCommParentId = parentId,
            this.newCommRootId = rootId
            this.newCommentLev = lev + 1
            if(replyTo){
                this.replyingTo = replyTo
            } 
            this.add = true
        },

        saveEdit: function(i, id){
            var self = this

             if(this.commentForEdit == ''){
                 return
             }
             
            function w(d){
                az.addRemSpinner(false, 'id', 'commentContainer')
                if(d.r == 'ok'){
                   let comm = self.comments.find(e => {
                       return e.id == id
                   }) 

                   comm.comment = self.commentForEdit
                } 


            }

            function n(){
                az.addRemSpinner(false, 'id', 'commentContainer')
            }
            az.addRemSpinner(true, 'id', 'commentContainer')
            this.cancelEdit(i)
            this.$root.app.apiClient.put('subs/data/comment', {id: id, comment: this.commentForEdit}, w, n)
        }
    },

    computed: {
     
    }

}
</script>

<style scoped>
    #xButt{
        background-color: transparent !important;
        position: fixed;
        font-size: 2rem !important;
        right: 10px;
        z-index: 400
    }

  
    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }
</style>